import { render } from "./Cor.vue?vue&type=template&id=133ff572&scoped=true"
import script from "./Cor.vue?vue&type=script&lang=js"
export * from "./Cor.vue?vue&type=script&lang=js"

import "./Cor.vue?vue&type=style&index=0&id=133ff572&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133ff572"]])

export default __exports__